module.exports = __webpack_public_path__ + "img/hoverBox3.c42f2ed3.png";